module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Report/Block","already_blocked":"You have already reported/blocked this post.","cancel":"Cancel","submit":"Report","error":"Failed to submit the report. Please check your input."}}')
  delete Component.options._Ctor
}
